import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { StudentHome } from './pages/StudentHome';
import { StudentReports } from './pages/StudentReports';
import { Workspace } from './pages/Workspace';
import { OrganizationMembers } from './pages/OrganizationMembers';
import { OrganizationOverview } from './pages/OrganizationOverview';
import { OrganizationSettings } from './pages/OrganizationSettings';
import { OrganizationStudents } from './pages/OrganizationStudents';
import { AdminClassrooms } from './pages/AdminClassrooms';
import { ClassroomDetail } from './pages/ClassroomDetail';
import { EducatorMonthlyDetail } from './pages/EducatorMonthlyDetail';
import { Groups } from './pages/Groups';
import { GroupDetail } from './pages/GroupDetail';
import { ThemeProvider } from './contexts/ThemeContext';
export function AppRouter() {
  return <ThemeProvider data-id="element-13">
      <BrowserRouter data-id="element-14">
        <Routes data-id="element-15">
          <Route path="/" element={<App data-id="element-17" />} data-id="element-16" />
          <Route path="/workspace" element={<Workspace data-id="element-19" />} data-id="element-18" />
          <Route path="/classes" element={<Groups data-id="element-21" />} data-id="element-20" />
          <Route path="/classes/:id" element={<GroupDetail data-id="element-23" />} data-id="element-22" />
          <Route path="/organization/overview" element={<OrganizationOverview data-id="element-25" />} data-id="element-24" />
          <Route path="/organization/educator/:educatorId/:month" element={<EducatorMonthlyDetail data-id="element-27" />} data-id="element-26" />
          <Route path="/organization/members" element={<OrganizationMembers data-id="element-29" />} data-id="element-28" />
          <Route path="/organization/students" element={<OrganizationStudents data-id="element-31" />} data-id="element-30" />
          <Route path="/organization/settings" element={<OrganizationSettings data-id="element-33" />} data-id="element-32" />
          <Route path="/organization/classrooms" element={<AdminClassrooms data-id="element-35" />} data-id="element-34" />
          <Route path="/organization/classrooms/:id" element={<ClassroomDetail data-id="element-37" />} data-id="element-36" />
          <Route path="/student" element={<StudentHome data-id="element-39" />} data-id="element-38" />
          <Route path="/student/reports" element={<StudentReports data-id="element-41" />} data-id="element-40" />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>;
}